const baseSize = 100;
const UiWidth = 375;
const maxScale = 1.28;
function setRem() {
  const {
    clientWidth
  } = document.documentElement;
  const scale = clientWidth / UiWidth;
  document.documentElement.style.fontSize = `${baseSize * Math.min(scale, maxScale)}px`;
}
setRem();
window.onresize = function () {
  setRem();
};